const defaultState = {
  isLoaded: false,
  quizs: [],
}

const quiz = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_QUIZ_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    case 'SET_QUIZ_ADD':
      return {
        ...state,
        isLoaded: true,
        quizs: [...state.quizs, action.data],
      };
    case 'SET_QUIZ_UP':
      return {
        ...state,
        isLoaded: true,
        quizs: state.quizs.map(_i => _i.id == action.data.id ? action.data : {..._i}),
      };
    case 'SET_QUIZ_DELETE':
      return {
        ...state,
        isLoaded: true,
        quizs: state.quizs.filter(_i => _i.id != action.data),
      };
    default:
      return state
  }
}

export default quiz;
